export default __webpack_public_path__ + "static/media/loading.68d0272c.gif";